import ApiClient from './ApiClient';

export default class ClaimApi extends ApiClient {
  /**
   * Жалоба на объекта нежвижимости
   * @param claim
   * @returns {*}
   */
  claimCreate (claim) {
    const {reasonId, dealType, realtyType, realtyId, text} = claim;

    return this.post(`${dealType}/${realtyType}/${realtyId}/claim`, { text, reasonId });
  }
}



// WEBPACK FOOTER //
// ./src/api/ClaimApi.js